import React, { useEffect, useState } from "react";
import { Link } from "@StarberryUtils";
import ScrollAnimation from "react-animate-on-scroll";
import Slider from "react-slick";
import { Button, Form, Container, FormControl, Row, InputGroup, Col, Dropdown } from "react-bootstrap";
import "./PropertyDescription.scss";
import DescriptionVideoImgDesktop from "../../../images/propertydetails/description-video-d.png"
import DescriptionVideoImgTablet from "../../../images/propertydetails/description-video-t.png"
import DescriptionVideoImgMobile from "../../../images/propertydetails/description-video-m.png"
import PlayVideo from '../../../Components/Play/PlayVideo';
import ReactMarkdown from "react-markdown"
import { getSrc } from "gatsby-plugin-image"
import CustomVideoPlay from "@Components/CustomVideo/CustomVideo.js";

import { inViewOptions } from '../../utils/animations';
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";

const containerVariants = {
    hidden: {
        opacity: 0
    },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.4,
            ease: [0.33, 1, 0.68, 1],
            duration: 0.4
        }
    }
}

const titleVariants = {
    hidden: {
        opacity: 0,
        y: 40
    },
    visible: {
        opacity: 1,
        y: 0,
        delay: 1.5,
        transition: {
            ease: [0.33, 1, 0.68, 1],
            duration: 1
        }
    }
}

const items = {
    hidden: {
        opacity: 0,
        y: 40
    },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            ease: [0.33, 1, 0.68, 1],
            duration: 0.3
        }
    }
}

const MotionColumn = motion(Col)

const PropertyDescription = (props) => {

    const [isPlay, setPlay] = useState(false);
    const [isPlayed, setPlayed] = useState(false);
    const [isPlaying, setPlaying] = useState(false);
    const [isClient, setClient] = useState(false);
    useEffect(() => {
        setClient(true);
    }, []);
    const settings = {
        dots: false,
        speed: 800,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 9999,
                settings: "unslick"
            },

            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },

        ],
    }
    return (
        <InView {...inViewOptions}>
            {({ ref, inView }) => {
                return (
                    <motion.section
                        ref={ref}
                        initial="hidden"
                        animate={inView ? "visible" : "hidden"}
                        variants={containerVariants}
                    >
                        <React.Fragment>
                            <section className="property-description details-intro careers">
                                <Container>
                                    <div className="property-description-content">
                                        <div className="property-description-col-1">
                                            <ScrollAnimation animateOnce={true} animateIn="fadeInUp">
                                                <motion.div variants={titleVariants}>
                                                    <div className="local-life">
                                                        <Row>
                                                            {props.Image?.url &&
                                                                <Col className="column-video" md={3} xl={3}>
                                                                    <div className="video-small-property-description"
                                                                    // onClick={(e) => {setPlayed(true)}}
                                                                    >
                                                                        <div className="video-wrap img-hover-zoom">
                                                                            {/* <picture>
                                        <source media="(min-width:992px)" srcSet={props.Image?.url} />
                                        <source media="(min-width:768px)" srcSet={props.Image?.url} />
                                        <img src={props.Image?.url} alt={props.Image?.alternativeText} />
                                    </picture> */}
                                                                            <img src={getSrc(props.Image?.url_sharp)} alt={props.Image?.alternativeText} />
                                                                        </div>
                                                                        {/* <span class="video-btn"><i class="icon-video"></i></span>  */}
                                                                        {props.Video_Url ?
                                                                            <CustomVideoPlay url={props.Video_Url} /> : null}
                                                                    </div>
                                                                </Col>
                                                            }
                                                            <Col className="column-text" md={props.Image?.url ? 9 : 12} xl={props.Image?.url ? 9 : 12}>
                                                                {isClient && props.Content ?
                                                                    <div className="local-life-text-content career-para">
                                                                        <p className="text-light1">
                                                                            <ReactMarkdown source={props.Content} allowDangerousHtml />
                                                                        </p>
                                                                    </div>
                                                                    : ""
                                                                }
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </motion.div>
                                            </ScrollAnimation>
                                        </div>
                                    </div>

                                </Container>

                                <PlayVideo
                                    isOpen={isPlay}
                                    isCloseFunction={setPlay}
                                    videoId="V8ksSGxo6no"
                                    isAutoPlay={1}
                                />
                                <PlayVideo
                                    isOpen={isPlaying}
                                    isCloseFunction={setPlaying}
                                    videoId="V8ksSGxo6no"
                                    isAutoPlay={1}
                                />
                                <PlayVideo
                                    isOpen={isPlayed}
                                    isCloseFunction={setPlayed}
                                    videoId="V8ksSGxo6no"
                                    isAutoPlay={1}
                                />
                            </section>
                        </React.Fragment>
                    </motion.section>
                )
            }}
        </InView>
    )
}

export default PropertyDescription;